module.exports = __webpack_public_path__ + "img/five_twenty.99e3dac1.svg";